import format from 'date-fns/format';
import React, { FunctionComponent, useMemo } from 'react';

import { getLocaleByCode } from '../../../utils/locale';
import { blogArticleUrl, webinarArticleUrl } from '../../../utils/utils';

import { Button } from '../../button/button';

import { IEmployeeBoxProps } from '../../employee-box/employee-box';
import { InternalLink } from '../../internal-link/internal-link';
import styles from './article-list-item.module.scss';

export interface IArticleItem extends React.PropsWithChildren<{}> {
  language: string;
  id: string;
  title: string;
  summary: string;
  author: IEmployeeBoxProps;
  slug: string;
  publicationDate: string;
  content: {
    value: string;
    modular_content: object;
  };
  fullWidthContent: {
    value: string;
  };
  categoryUrl: string;
  categoryName: string;
  image: {
    url: string;
    description: string;
  };
  featured: boolean;
  contentHtml: string;
}

export interface IArticleListItemProps {
  data: IArticleItem;
  className?: string;
}

export const ArticleListItem: FunctionComponent<IArticleListItemProps> = props => {
  const {
    data: {
      language,
      title,
      summary,
      author: { firstName, lastName },
      slug,
      publicationDate,
      categoryUrl,
      image: { url, description: alt }
    },
    className
  } = props;

  const articleUrl =
    categoryUrl === ''
      ? webinarArticleUrl(slug)
      : blogArticleUrl(slug, categoryUrl);
  const locale = useMemo(() => getLocaleByCode(language), [language]);

  return (
    <article className={`${styles.container} ${className}`}>
      <InternalLink className={styles.articleWrapper} url={articleUrl}>
        <div className={styles.imageWrapper}>
          <img className={styles.articleImage} src={url} alt={alt} />
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.articleTitle}>{title}</h2>
          <p className={styles.articleDescription}>{summary}</p>
          {categoryUrl === '' && (
            <Button
              className={styles.button}
              size="medium"
              border="rectangular"
              internalLink=""
              theme="primary"
            >
              Learn More
            </Button>
          )}
          {publicationDate !== '' && (
            <p className={styles.articleInfo}>
              <span>
                {firstName} {lastName}
              </span>
              <span className={styles.publicationDate}>
                {format(new Date(publicationDate), 'dd MMMM yyyy', { locale })}
              </span>
            </p>
          )}
        </div>
      </InternalLink>
    </article>
  );
};
